import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-24 px-4 bg-white relative overflow-hidden" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <FadeIn data-id="element-125">
          <div className="text-center mb-16" data-id="element-126">
            <h2 className="text-3xl md:text-4xl font-serif text-burgundy-900 mb-8 leading-relaxed" data-id="element-127">
              No es que no lo ames.
              <br data-id="element-128" />
              No es que ya no te guste.
              <br data-id="element-129" />
              <span className="text-burgundy-600 italic" data-id="element-130">
                Es que te da pena.
              </span>
            </h2>
            <div className="w-24 h-1 bg-gold-400 mx-auto rounded-full mb-8" data-id="element-131" />
          </div>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl text-burgundy-900/80 leading-relaxed" data-id="element-132">
          <FadeIn delay={100} data-id="element-133">
            <p data-id="element-134">
              Pena de iniciar. Pena de que te diga "hoy no". Pena de sentirte
              intenso/a, needy, o de "hacer el ridículo".
            </p>
          </FadeIn>

          <FadeIn delay={200} data-id="element-135">
            <p data-id="element-136">
              Y entonces haces lo que casi todos hacen: te quedas quieto/a…
              esperando que el momento se arregle solo.
            </p>
          </FadeIn>
        </div>

        <div className="mt-20 grid gap-8 md:grid-cols-2" data-id="element-137">
          <FadeIn delay={300} className="bg-cream-50 p-8 rounded-2xl border border-cream-200" data-id="element-138">
            <h3 className="text-xl font-serif font-bold text-burgundy-900 mb-4" data-id="element-139">
              Lo que intentaron (y falló)
            </h3>
            <ul className="space-y-4" data-id="element-140">
              <li className="flex items-start" data-id="element-141">
                <span className="text-burgundy-400 mr-3" data-id="element-142">✕</span>
                <span className="text-sm text-burgundy-800" data-id="element-143">
                  "A ver si se da" (La rutina nunca produce el momento perfecto)
                </span>
              </li>
              <li className="flex items-start" data-id="element-144">
                <span className="text-burgundy-400 mr-3" data-id="element-145">✕</span>
                <span className="text-sm text-burgundy-800" data-id="element-146">
                  Hacer un intento grande (Mucho riesgo emocional)
                </span>
              </li>
              <li className="flex items-start" data-id="element-147">
                <span className="text-burgundy-400 mr-3" data-id="element-148">✕</span>
                <span className="text-sm text-burgundy-800" data-id="element-149">
                  Hablarlo serio (Se siente como reclamo y mata el deseo)
                </span>
              </li>
            </ul>
          </FadeIn>

          <FadeIn delay={400} className="bg-burgundy-50 p-8 rounded-2xl border border-burgundy-100" data-id="element-150">
            <h3 className="text-xl font-serif font-bold text-burgundy-900 mb-4" data-id="element-151">
              El verdadero problema
            </h3>
            <p className="text-burgundy-800 mb-4" data-id="element-152">
              No es falta de pasión. Es <strong data-id="element-153">exceso de exposición</strong>.
            </p>
            <p className="text-sm text-burgundy-700" data-id="element-154">
              Cuando iniciar se siente como un riesgo, tu cuerpo se protege.
              Necesitas una forma de acercarte que sea segura, donde el "no" no
              duela y el "sí" fluya natural.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}